import React from "react";
import { ShieldAlert } from "lucide-react";
import type { ConfirmationRequest } from "./types";

function formatRecipients(value: unknown): string {
  if (Array.isArray(value)) return value.filter(Boolean).join(", ") || "recipient";
  if (typeof value === "string" && value.trim()) return value;
  return "recipient";
}

export const ACTION_DESCRIPTIONS: Record<string, (input: Record<string, unknown>) => string> = {
  send_email: (input) => `Send email to ${formatRecipients(input.to)} \u2014 "${input.subject ?? "(no subject)"}"`,
  create_event: (input) => `Create calendar event: "${input.title ?? "(untitled)"}" at ${input.start ?? "TBD"}`,
  schedule_meeting: (input) => `Create video meeting: "${input.name ?? "Meeting"}"`,
};

interface ActionConfirmationProps {
  confirmation: ConfirmationRequest;
  onConfirm: () => void;
  onReject: () => void;
}

export const ActionConfirmation: React.FC<ActionConfirmationProps> = ({
  confirmation,
  onConfirm,
  onReject,
}) => {
  const descFn = ACTION_DESCRIPTIONS[confirmation.tool_name];
  const description = descFn ? descFn(confirmation.input) : `Execute: ${confirmation.tool_name}`;

  return (
    <div className="rounded-lg border border-amber-500/30 bg-amber-500/10 p-3 my-2 space-y-2">
      <div className="flex items-start gap-2">
        <ShieldAlert className="size-4 text-amber-400 shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-medium text-amber-200">Action requires confirmation</p>
          <p className="text-xs text-amber-300 mt-0.5">{description}</p>
        </div>
      </div>
      <div className="flex gap-2 ml-6">
        <button
          type="button"
          onClick={onConfirm}
          className="px-3 py-1 text-xs rounded-md bg-amber-600 hover:bg-amber-500 text-white font-medium transition-colors"
        >
          Confirm
        </button>
        <button
          type="button"
          onClick={onReject}
          className="px-3 py-1 text-xs rounded-md bg-zinc-700 hover:bg-zinc-600 text-zinc-300 font-medium transition-colors"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};
